<template>
    <div class="Order">
      <search-box
        :columns="searchColumn"
        @search="search"
        :defaultValue="formData"
        :areaChangeFn="getRegions"
        @btnReset="handleReset"
      />
      <QS-common-table
      v-loading="oLoading.search"
      :data="tableData"
      :columns="tableColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
    />
    </div>
  </template>

<script>
import config from './config'
// eslint-disable-next-line import/no-cycle
import { getOrderList, getPurchaseStoreList } from './services'
import { getPurchaseProviderList } from '../maintenanceCommonServices/services'
import { getRegions } from '@/api/global'
import { pickBy as ommitEmptyFields } from 'lodash'
import moment from 'moment'

export default {
  data() {
    const {
      searchColumn,
      tableColumns,
    } = config.call(this)
    return {
      oLoading: {
        search: false,
      },
      getRegions,
      searchColumn,
      tableColumns,
      tableData: [],
      formData: {
        createTime: this.getSectionTime(),
      },
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      params: {},
    }
  },
  methods: {
    getSectionTime(day = -6, formData = 'YYYY-MM-DD HH:mm:ss') {
      let startTime = ''
      let enTime = ''
      if (day < 0) {
        startTime = `${moment().add(day, 'days').format(formData).substring(0, 11)}00:00:00`
        enTime = `${moment(new Date().getTime()).format(formData).substring(0, 11)}23:59:59`
      } else {
        startTime = `${moment(new Date().getTime()).format(formData).substring(0, 11)}00:00:00`
        enTime = `${moment().add(day, 'days').format(formData).substring(0, 11)}23:59:59`
      }

      return [startTime, enTime]
    },
    search(params) {
      // 下单时间
      if (params.createTime && params.createTime.length) {
        params.createStartTime = new Date(params.createTime[0]).getTime()
        params.createEndTime = new Date(params.createTime[1]).getTime()
        delete params.createTime
      }
      // 支付时间
      if (params.payTime && params.payTime.length) {
        params.payStartTime = new Date(params.payTime[0]).getTime()
        params.payEndTime = new Date(params.payTime[1]).getTime()
        delete params.payTime
      }
      // 预约时间
      if (params.usedTime && params.usedTime.length) {
        params.usedTimeStart = new Date(params.usedTime[0]).getTime()
        params.usedTimeEnd = new Date(params.usedTime[1]).getTime()
        delete params.usedTime
      }
      this.params = params
      this.query()
    },
    handleReset() {
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.params = {}
      this.formData = {
        createTime: this.getSectionTime(),
      }

      this.getSearchTime()
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleGoToDetail(row) {
      this.$router.push({
        name: 'maintenanceOrderDetail',
        query: {
          orderId: row.orderId,
        },
      })
    },
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.query()
    },
    getSearchTime() {
      if (this.formData.createTime && this.formData.createTime.length) {
        this.params.createStartTime = new Date(this.formData.createTime[0]).getTime()
        this.params.createEndTime = new Date(this.formData.createTime[1]).getTime()
      }
      this.query()
    },
    // 请求数据
    query() {
      this.oLoading.search = true
      getOrderList({
        ...ommitEmptyFields(this.params),
        pageSize: this.paginationData.pageSize,
        pageNum: this.paginationData.pageNum,
        businessType: 300, // 300 维保
      }).then((res) => {
        if (res) {
          const { code, data } = res
          if (code === 1) {
            const { items, totalNum } = data
            this.tableData = items
            this.paginationData.total = totalNum
          }
        }
      }).finally(() => {
        this.oLoading.search = false
      })
    },
    // 获取门店名称(ok)
    async getPackageBusinessList() {
      const { data, code } = await getPurchaseStoreList()
      if (code === 1) {
        this.searchColumn.forEach((item) => {
          if (item.key === 'businessId') {
            data.forEach((child) => {
              child.businessName = `${child.businessName}(${child.businessId})`
            })
            item.source = data
          }
        })
      }
    },
    // 获取维保服务商名称(ok)
    async getmaintenanceISP() {
      const { data, code } = await getPurchaseProviderList()
      if (code === 1) {
        this.searchColumn.forEach((item) => {
          if (item.key === 'tenantId') {
            data.forEach((child) => {
              child.tenantName = `${child.tenantName}(${child.tenantId})`
            })
            item.source = data
          }
        })
      }
    },
  },
  created() {
    this.getPackageBusinessList()
    this.getmaintenanceISP()
    this.getSearchTime()
  },
}
</script>
